module.exports = __webpack_public_path__ + "img/00b—Pop-up confirmation dialog.0ccdf9a7.jpg";